
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-excited/news/[slug]",
      function () {
        return require("private-next-pages/get-excited/news/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-excited/news/[slug]"])
      });
    }
  